import React from "react";
import { ReactTyped } from "react-typed";
import { WavyBackground } from "./WavyBackground";
import { motion } from "framer-motion";

const Hero = ({ darkMode }) => {
  const waveColors = darkMode
    ? ["#1c1c1c", "#2c5364", "#203a43"] // Dark mode wave colors
    : ["#e5471f", "#7fc7e6", "#4b534e"]; // Light mode wave colors

  const backgroundFill = darkMode ? "#1c1c1c" : "#f5f3eb";

  return (
    <WavyBackground
      colors={waveColors}
      waveWidth={60}
      backgroundFill={backgroundFill}
      blur={15}
      speed="fast"
      waveOpacity={0.6}
    >
      <div className="relative flex flex-col items-center justify-center text-center min-h-screen px-6">
        
        {/* Title */}
        <motion.h1
          className="text-[35px] md:text-[50px] lg:text-[60px] leading-[40px] md:leading-[55px] lg:leading-[70px] font-bold text-[#4b534e] dark:text-white"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          Welcome to <span className="text-[#4b534e] dark:text-[#7fc7e6]">Kura Digital</span>
        </motion.h1>

        {/* Subtitle */}
        <motion.p
          className="mt-4 text-lg md:text-xl text-[#4b534e] dark:text-gray-400 max-w-2xl"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          Tailored digital solutions to empower your business.
        </motion.p>

        {/* Typed Effect with Visible Colors in Both Modes */}
        <ReactTyped
          strings={[
            "Software Development",
            "E-Commerce Solutions",
            "Creative Web Design",
          ]}
          typeSpeed={80}
          backSpeed={50}
          loop
          className="text-2xl font-medium text-[#4b534e] dark:text-gray-300 mt-4"
        />
      </div>
    </WavyBackground>
  );
};

export default Hero;










